// utils/cookies.js
export function setCookie(name, value, days = 7) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();

  // ✅ store objects as JSON
  const v =
    typeof value === "string" ? value : JSON.stringify(value ?? null);

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(
    v
  )}; Expires=${expires}; Path=/; SameSite=Lax`;
}

export function getCookie(name) {
  const key = encodeURIComponent(name) + "=";
  const parts = document.cookie.split("; ");
  for (const p of parts) {
    if (p.startsWith(key)) return decodeURIComponent(p.slice(key.length));
  }
  return "";
}

// ✅ helper: get cookie and parse JSON (returns null if missing/invalid)
export function getCookieJSON(name) {
  const raw = getCookie(name);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function deleteCookie(name) {
  document.cookie = `${encodeURIComponent(
    name
  )}=; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=/; SameSite=Lax`;
}

export function clearCookies() {
  const cookies = document.cookie ? document.cookie.split("; ") : [];

  for (const cookie of cookies) {
    const eqIndex = cookie.indexOf("=");
    const rawName = eqIndex > -1 ? cookie.slice(0, eqIndex) : cookie;
    const name = decodeURIComponent(rawName.trim());

    document.cookie = `${encodeURIComponent(
      name
    )}=; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=/; SameSite=Lax`;
  }
}